export const EMPTY_ASSET_LABEL = '-';
